import { FeatureFlagKey } from "@redotech/feature-flags-model/keys";
import { useRequiredContext } from "@redotech/react-util/context";
import { RedoPlatformAuthRpcClientContext } from "@redotech/redo-merchant-app-common/platform/redo-platform-rpc-client-provider";
import { TeamContext } from "@redotech/redo-web/context/team-context";
import { useQuery } from "@tanstack/react-query";

export interface ZipCodeFraudFeatureFlagState {
  enabled: boolean;
  pending: boolean;
}

export function getZipCodeFraudFeatureFlagQueryKey(teamId: string) {
  return ["featureFlag", FeatureFlagKey.ZIP_CODE_FRAUD, teamId] as const;
}

export function useZipCodeFraudFeatureFlag(): ZipCodeFraudFeatureFlagState {
  const platformRpcClient = useRequiredContext(
    RedoPlatformAuthRpcClientContext,
  );
  const team = useRequiredContext(TeamContext);

  const query = useQuery({
    queryKey: getZipCodeFraudFeatureFlagQueryKey(team._id.toString()),
    queryFn: async () => {
      const response = await platformRpcClient.getFeatureFlag({
        flagKey: FeatureFlagKey.ZIP_CODE_FRAUD,
      });
      return response.enabled;
    },
    staleTime: Infinity,
  });

  return { enabled: query.data ?? false, pending: query.isPending };
}
